<template>
  <footer class="bg-cover bg-center text-white py-10 main-back">
    <div class="py-2 px-6 max-w-screen-2xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <!-- Logo & Socials -->
        <div>
          <router-link to="/">
            <div class="flex-shrink-0 -ml-7">
              <img
                src="../assets/images/Mshel-group-logo.png"
                alt="Logo"
                class="h-16 hover:scale-105 transition-transform duration-200"
              />
            </div>
          </router-link>
          <p class="text-sm hidden md:block">
            Building Excellence, Enhancing lives
          </p>
          <div class="flex gap-2 mt-4">
            <a
              href="https://www.facebook.com/MshelHomes/"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-facebook"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/mshel-homes-limited"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-linkedin"></i>
            </a>
            <a
              href="https://www.youtube.com/@mshelhomes"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-youtube"></i>
            </a>
            <a
              href="https://www.instagram.com/mshelhomes/"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-instagram"></i>
            </a>
            <a
              href="https://twitter.com/mshelofficial"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-twitter"></i>
            </a>
            <a
              href="https://www.tiktok.com/@mshelhomes"
              class="p-2 w-8 h-8 flex items-center justify-center border border-white rounded-full hover:bg-yellow hover:text-white hover:border-none"
            >
              <i class="fa-brands fa-tiktok"></i>
            </a>
          </div>
        </div>

        <!-- Our Subsidiaries -->
        <div>
          <p class="font-semibold text-lg mb-6">Our Subsidiaries</p>
          <ul class="space-y-2 text-sm">
            <li>
              <a
                href="https://mshelhomes.com"
                target="_blank"
                class="hover:text-yellow"
                >Mshel Homes</a
              >
            </li>
            <li>
              <a
                href="https://lisasuites.com"
                target="_blank"
                class="hover:text-yellow"
                >Lisa Suites</a
              >
            </li>
            <li>
              <a
                href="https://mshelconstruction.com"
                target="_blank"
                class="hover:text-yellow"
                >Mshel Construction</a
              >
            </li>
            <li>
              <a
                href="https://mshelfoundation.org/"
                target="_blank"
                class="hover:text-yellow"
                >Mshel Foundation</a
              >
            </li>
            <li>
              <a
                href="https://mshelblocksandmachineries.com"
                target="_blank"
                class="hover:text-yellow"
                >Mshel Blocks & Machineries</a
              >
            </li>
            <li>
              <a
                href="https://mshelprints.com"
                target="_blank"
                class="hover:text-yellow"
                >Mshel Prints</a
              >
            </li>
            <li>
              <a
                href="https://barkaumshelia.com/mshel-club"
                target="_blank"
                class="hover:text-yellow"
                >Mshel Consult</a
              >
            </li>
          </ul>
        </div>

        <!-- Quick Links -->
        <div>
          <p class="font-semibold text-lg mb-6">Quick Links</p>
          <ul class="space-y-2 text-sm">
            <li><a href="/about" class="hover:text-yellow">About Us</a></li>
            <li>
              <a href="/services" class="hover:text-yellow">The hub</a>
            </li>
            <li><a href="/blog" class="hover:text-yellow">Blog</a></li>
          </ul>
        </div>

        <!-- Phone -->
        <div>
          <p class="font-semibold text-lg mb-6">Phone</p>
          <a
            href="tel:+2348104444229"
            class="block text-sm hover:text-yellow-500"
            >+234-810-444-4229</a
          >
          <a
            href="tel:+2348123333326"
            class="block text-sm hover:text-yellow-500"
            >+234-812-333-3326</a
          >
        </div>
      </div>

      <!-- Footer Bottom -->
      <div
        class="flex flex-col md:flex-row justify-center items-center mt-10 border-t border-gray-500 pt-4 text-sm"
      >
        <p>© 2025 Mshel Homes. Designed by Mshel Integrated Systems</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.main-back {
  background-image: url("../assets/images/HERO Pages ALL 2.png");
}
</style>
